module.exports = __webpack_public_path__ + "assets/ico_warning.5376c3fe.svg";